import { useQuery } from "@tanstack/react-query";

export interface BuildVersionInfo {
	version: string;
	marketingVersion: string;
	environment?: string;
}

/** Fetch the build version from `/api/version` (cached for the session). */
export function useBuildVersion() {
	return useQuery({
		queryKey: ["build-version"],
		queryFn: async (): Promise<BuildVersionInfo> => {
			const response = await fetch("/api/version");
			if (!response.ok) {
				throw new Error(`Failed to load version (${response.status})`);
			}
			return (await response.json()) as BuildVersionInfo;
		},
		staleTime: Number.POSITIVE_INFINITY,
	});
}
